import AppleStoreSvg from "./assets/icons/logo/apple-store-logo.svg";
import GooglePlaySvg from "./assets/icons/logo/google-play-logo.svg";
import HuFlag from "./assets/icons/flags/flag-hu.svg";
import EnFlag from "./assets/icons/flags/flag-en.svg";
import LvFlag from "./assets/icons/flags/flag-lv.svg"
import GreenPipe from "./assets/icons/pipe-green.svg";
import BlockBenLightLogo from "./assets/icons/logo/blockben-logo-light.svg";
import BlockBenDarkLogo from "./assets/icons/logo/blockben-logo-dark.svg";
import Success from "./assets/icons/success.svg";
import ArrowUp from "./assets/icons/arrow-up.svg"
import ArrowDown from "./assets/icons/arrow-down.svg"
import Eye from "./assets/icons/eye.svg";
import Load from "./assets/icons/load.svg";
import Cancel from "./assets/icons/cancel.svg";


export const ICONS = {
	AppleStoreSVG: AppleStoreSvg,
	GooglePlaySVG: GooglePlaySvg,
	HUFlag: HuFlag,
	ENFlag: EnFlag,
	LVFlag: LvFlag,
	
	BlockBenLightLogo: BlockBenLightLogo,
	BlockBenDarkLogo: BlockBenDarkLogo,
	GreenPipe: GreenPipe,
	Success: Success,
    ArrowUpSVG: ArrowUp,
    ArrowDownSVG: ArrowDown,
	Eye: Eye,
	Load: Load,
	Cancel: Cancel,
};

export type IconTypes = typeof ICONS;
